export const DATE_FORMAT = 'YYYY-MM-DD';
export const PRICING_DATETIME_FORMAT = 'MM/dd/yyyy HH:mm';
export const PRODUCTS_FEEDS_DATETIME_FORMAT = 'dd MMM yyyy HH:mm';
export const MOMENT_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
export const ANALYTICS_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.sss'Z'";
export const DATE_FORMAT_US = 'MM/dd/yyyy';
export const DATE_FORMAT_US_SHORT = 'MM/dd';
export const DATE_FORMAT_REPORTS_ENDPOINT = 'yyyy-MM-dd';
export const DMY_FORMAT = 'dd MMMM yyyy';
